import React, { FC, useEffect, useState } from "react";
import axiosInstant from "../../../../api";
import { SingleFilter } from "./singleFilter";
import { getBrandLogoUrl } from "../../../../utils/brandLogo";
import { ISingleOption, OptionMaxLimit, getFilterProps } from "./helper";

interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryParams?: any;
  options?: Array<ISingleOption>;
}

export const BrandFilter: FC<Props> = ({
  onFilterSelect,
  queryParams,
  options,
  ...rest
}) => {
  const [internalBrands, setInternalBrands] = useState<Array<ISingleOption>>(
    []
  );

  const fetchBrands = () => {
    axiosInstant
      .get(`/brands?all=true&${queryParams}`)
      .then((response) => {
        const output = response.data.rows.map((res: any) => {
          if (!res.id || !res.name) return null;
          const name =
            res.name.length > OptionMaxLimit
              ? `${res.name.slice(0, OptionMaxLimit)} ...`
              : res.name;
          return { ...res, name, image: res.image || getBrandLogoUrl(res) };
        });
        setInternalBrands(output.filter((e: ISingleOption) => !!e));
      })
      .catch((error) => {
        console.error(error.response);
      });
  };

  useEffect(() => {
    if (!options) {
      fetchBrands();
    }
  }, [options]);

  const brandsList = options || internalBrands;

  return (
    <SingleFilter
      {...rest}
      {...getFilterProps(brandsList, "brandId")}
      updateSearch={onFilterSelect}
      thumbnails
    />
  );
};
